import type { ProductCustomerNotificationModel } from 'autogen/swagger/all';
import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const NotificationFormQuickViewState = mediatorAtom<{
    isOpen: boolean;
    notificationModel?: ProductCustomerNotificationModel;
}>({ isOpen: false });

export default function useNotificationFormQuickView() {
    return useMediatorState(NotificationFormQuickViewState);
}
